<script setup lang="ts" generic="T">
const {
    selected,
    id,
    allowMultiSelect = false,
    isSelectDisabled = false,
    tinted = false,
} = defineProps<{
    selected: boolean;
    id: T;
    allowMultiSelect?: boolean;
    isSelectDisabled?: boolean;
    tinted?: boolean;
}>();

const emit = defineEmits<{
    select: [{ id: T; isSelected: boolean }];
    dbClick: [];
}>();

function select(isSelected: boolean) {
    if (isSelectDisabled) {
        return;
    }
    emit('select', { id, isSelected });
}
</script>

<template>
    <div
        :class="[
            $attrs.class,
            'shadow-drop my-1 grid w-full items-center rounded-xl border-2 px-2 py-2 text-center',
            tinted ? 'bg-gray-100' : 'bg-white',
            'hover:border-secondary hover:shadow-shadow-hover',
            'shadow-shadow border-transparent',
        ]"
        @dblclick="$emit('dbClick')"
    >
        <div v-if="allowMultiSelect" class="flex items-center gap-4">
            <BaseCheckbox
                :id="`select-${id}`"
                label=""
                :model-value="selected"
                class="cursor-pointer"
                :disabled="isSelectDisabled"
                @update:model-value="select($event)"
            />
        </div>
        <slot name="columns" />
        <div class="flex justify-end gap-4">
            <slot name="buttons" />
        </div>
    </div>
</template>
